<!--
 * @Description: 新版关键词统计
 * @Author: yuxin
 * @Date: 2024-09-30 11:14:44
 * @LastEditors: Do not edit
 * @LastEditTime: 2025-04-16 09:19:36
 * @FilePath: \mgr_web\src\views\chat\newKeyWordStatistics.vue
-->
<template>
  <div class="keyWord-statistics-container">
    <el-scrollbar style=" height: 84vh;">
      <div class="module-wrap" v-for="(item, index) in dataList" :key="index">
        <!-- 搜索 -->

        <div class="filter-bar">
          <el-select
            v-if="!isNewEdition"
            v-model="item.searchParams.searchType"
            placeholder="请选择类型"
            size="mini"
            style="margin-right: 10px;"
            @change="getChatData(index, item.id)"
          >
            <el-option
              v-for="item in selectOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <el-date-picker
            class="filter-date-picker"
            v-model="item.searchParams.timeInterval"
            size="mini"
            type="daterange"
            :editable="false"
            value-format="yyyy-MM-dd"
            range-separator="~"
            start-placeholder="统计时间"
            end-placeholder="统计时间"
            @change="timeIntervalChange(index, item.id)"
            :picker-options="pickerOptions"
            :clearable="false"
          >
          </el-date-picker>
        </div>
        <!-- 标题 -->
        <div class="title-bar">
          <div class="chat-title">
            {{ isNewEdition ? "关键词统计 Top20" : item.name }}
          </div>
          <div class="detail-btn" @click="handleClickDetail(index, item)">
            明细<i class="el-icon-arrow-right"></i>
          </div>
        </div>
        <div :id="item.id" style="height: 300px; width: 100%;"></div>
      </div>
    </el-scrollbar>
    <!-- 明细组件 -->
    <NewKeyWordStatisticsDetail
      ref="NewKeyWordStatisticsDetailRef"
      :type="type"
      v-if="newKeyWordStatisticsDetailShow"
      :id="id"
      @newKeyWordStatisticsDetailClose="newKeyWordStatisticsDetailClose"
    />
    <!-- <el-dialog
      :visible.sync="dialogVisible"
      width="70%"
      :close-on-click-modal="false"
    >
      <div class="staff-chat-supervise-search">
        <div class="serach-left">
          <el-date-picker
            v-model="searchTableTime"
            size="mini"
            type="daterange"
            :editable="false"
            value-format="yyyy-MM-dd"
            range-separator="~"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            @change="handleTime"
            :picker-options="pickerOptions"
            :clearable="false"
            style="width: 240px; margin-right: 10px"
          >
          </el-date-picker>
          <el-input
            size="mini"
            suffix-icon="el-icon-search"
            style="width: 190px;margin-right: 10px"
            v-model="table2Params.wordName"
            placeholder="关键词"
            @blur="handleConsultList"
            @clear="handleConsultList"
            clearable
          >
          </el-input>
          <el-input
            size="mini"
            suffix-icon="el-icon-search"
            style="width: 190px;margin-right: 10px"
            v-model="table2Params.userName"
            placeholder="姓名"
            @blur="handleConsultList"
            @clear="handleConsultList"
            clearable
          >
          </el-input>
        </div>
      </div>
      <el-table
        size="small"
        :data="tableData"
        fit
        @row-click="handleclick"
        highlight-current-row
        :header-cell-style="{ background: '#F9F9F9' }"
        height="calc(100vh - 338px)"
        empty-text="暂无关键词数据"
        ref="cusChatTable"
        style="font-size: 13px"
      >
        <el-table-column
          align="center"
          prop="wordName"
          label="关键词"
          min-width="150"
        ></el-table-column>
        <el-table-column
          align="center"
          label="归属分类"
          min-width="150"
          prop="wordTypeName"
        >
        </el-table-column>
        <el-table-column
          prop="createTime"
          align="center"
          label="出现时间"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="hitCount"
          align="center"
          label="聊天内容"
          min-width="80"
        >
          <template slot-scope="scope">
            <div class="tag-wrap">
              <span class="more-users" @click="handleChactClick(scope.row, 2)"
                >查看</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="externalName"
          align="center"
          label="涉及客户"
          min-width="80"
        ></el-table-column>
        <el-table-column
          prop="departName"
          label="归属部门"
          min-width="250"
          align="center"
          :show-overflow-tooltip="false"
        >
        </el-table-column>
      </el-table>
      <Pagination
        :childMsg="pageparm"
        :pageSizes="pageSizes"
        @callBack="callBack"
      ></Pagination>
    </el-dialog> -->
  </div>
</template>
<script>
import {
  getConsultChat,
  staticUser,
  getUsersChat,
  getSensitiveChat,
} from "@/api/senWord/senWord.js";
import { getSessionVersion } from "@/api/staff/staff.js";
import SenDetail from "./components/senDetail.vue";
import SenWordChatCommon from "./components/SenWordChatCommon.vue";
import { getNewDate, timeFormat, getToday } from "@/utils/common.js";
import NewKeyWordStatisticsDetail from "./components/newKeyWordStatisticsDetail.vue";
export default {
  name: "NewKeyWordStatistics",
  components: {
    SenDetail,
    SenWordChatCommon,
    NewKeyWordStatisticsDetail,
  },
  data() {
    return {
      /** 判断绘画存档内容新旧版 */
      isNewEdition: false,
      /** 统计的模块数据 */
      dataList: [
        {
          id: "keyWordChat",
          name: "需求捕捉词频  Top20",
          color: ["#2478f2"],
          /** 获取关键词统计的请求参数数据 */
          searchParams: {
            /** 搜索类型 */
            searchType: "ALL",
            /** 搜索时间 默认是当前时间和往前的30天 */
            timeInterval: getNewDate(),
          },
        },
        // {
        //   id: "SensitiveWordsChat",
        //   name: "敏感词词汇  Top20",
        //   color: ["#f39423"],
        // },
        // {
        //   id: "employeeWordsChat",
        //   name: "员工敏感词统计",
        //   color: ["#f39423"],
        // },
      ],

      /** 筛选条件的下拉数据 */
      selectOptions: [
        {
          value: "ALL",
          label: "全部",
        },
        {
          value: "EXT",
          label: "只看客户",
        },
      ],

      // /** 获取关键词统计的请求参数数据 */
      // searchParams: {
      //   /** 搜索类型 */
      //   searchType: [],
      //   /** 搜索时间 默认是当前时间和往前的30天 */
      //   timeInterval: getNewDate(),
      // },

      /** 当前时间日期选择器特有的选项参考下表 */
      pickerOptions: {
        /** 选中日期后会执行的回调，只有当 daterange 或 datetimerange 才生效  */
        onPick: ({ maxDate, minDate }) => {
          this.choiceDate = minDate.getTime();
          if (maxDate) {
            this.choiceDate = "";
          }
        },

        /** 设置禁用状态，参数为当前日期，要求返回 */
        disabledDate: (time) => {
          if (this.choiceDate && this.choiceDate != null) {
            const one = 30 * 24 * 3600 * 1000;
            const minTime = this.choiceDate - one;
            const maxTime = this.choiceDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        },
      },

      /** 关键词统计明细表格数据 */
      tableData: [],
      /** 敏感词统计明细表格数据 */
      tableData1: [],
      /** 员工敏感词统计明细表格数据  */
      tableData2: [],

      /** 关键词统计请求参数 */
      table1Params: {
        current: 1,
        size: 20,
        wordName: "",
        userName: "",
        startTime: "",
        endTime: "",
      },

      /** 敏感词请求参数 */
      table2Params: {
        current: 1,
        size: 20,
        wordName: "",
        userName: "",
        startTime: "",
        endTime: "",
        show: "ALL",
      },

      /** 员工敏感词统计 */
      table3Params: {
        current: 1,
        size: 20,
        wordName: "",
        userName: "",
        startTime: "",
        endTime: "",
      },

      /** 详情的类型  1：关键词 2：敏感词*/
      type: 1,
      /** 控制详情组件显示隐藏 */
      newKeyWordStatisticsDetailShow: false,
    };
  },
  methods: {
    /** 获取新旧版本绘画存档 */
    getVersion() {
      getSessionVersion(localStorage.getItem("Authorization"))
        .then((res) => {
          if (res && res.error && res.error.code === 200) {
            this.isNewEdition = res.data;
            window.localStorage.setItem("isNewEdition", this.isNewEdition);
            console.log("获取新旧版本成功");
            if (this.isNewEdition) {
              /** 新版 */
              this.getkeyWordChatData();
            } else {
              /** 新版暂时没有敏感词功能，所以新版先只在旧版显示 */
              let oldVersionChat = [
                {
                  id: "SensitiveWordsChat",
                  name: "敏感词词汇  Top20",
                  color: ["#f39423"],
                  /** 获取关键词统计的请求参数数据 */
                  searchParams: {
                    /** 搜索类型 */
                    searchType: "ALL",
                    /** 搜索时间 默认是当前时间和往前的30天 */
                    timeInterval: getNewDate(),
                  },
                },
                {
                  id: "employeeWordsChat",
                  name: "员工敏感词统计  Top20",
                  color: ["#f39423"],
                  /** 获取关键词统计的请求参数数据 */
                  searchParams: {
                    /** 搜索类型 */
                    searchType: "ALL",
                    /** 搜索时间 默认是当前时间和往前的30天 */
                    timeInterval: getNewDate(),
                  },
                },
              ];

              /** 合并统计表格 */
              this.dataList = this.dataList.concat(oldVersionChat);
              console.log("dataList++++123", this.dataList);
              /** 旧版 */
              /** 获取关键次统计图表数据 */
              if (this.dataList && this.dataList.length) {
                this.dataList.forEach((item, index) => {
                  this.getChatData(index, item.id);
                });
              }
            }
          } else {
            // this.$message.error("获取版本参数失败")
            console.log("新旧版本参数获取失败", err);
          }
        })
        .catch((err) => {
          // this.$message.error("获取版本参数失败")
          console.log("新旧版本参数获取失败", err);
        });
    },

    /** 新版 获取关键词统计图表数据 */
    getkeyWordChatData() {
      /** 接口时间查询开始时间必须携带时分秒00：00：00，结束时间 必须携带 23:59:59，原获取时间公共函数有做处理
       * 不需要页面代码加上，但使用时间选择器选择后没有携带所以必须手动加上，这里写判断区分，有携带则不加，没携带必须加上
       */
      let startTime = "";
      if (
        this.dataList[0].searchParams.timeInterval &&
        this.dataList[0].searchParams.timeInterval.length
      ) {
        if (this.dataList[0].searchParams.timeInterval[0]) {
          startTime =
            this.dataList[0].searchParams.timeInterval[0].split(" ").length > 1
              ? this.dataList[0].searchParams.timeInterval[0]
              : this.dataList[0].searchParams.timeInterval[0] + " 00:00:00";
        } else {
          startTime = "";
        }
      }
      let endTime = "";
      if (
        this.dataList[0].searchParams.timeInterval &&
        this.dataList[0].searchParams.timeInterval.length
      ) {
        if (this.dataList[0].searchParams.timeInterval[1]) {
          endTime =
            this.dataList[0].searchParams.timeInterval[1].split(" ").length > 1
              ? this.dataList[0].searchParams.timeInterval[1]
              : this.dataList[0].searchParams.timeInterval[1] + " 23:59:59";
        } else {
          endTime = "";
        }
      }
      let requestParams = {
        current: 1,
        size: 20,
        startTime: startTime,
        endTime: endTime,
        show: this.dataList[0].searchParams.searchType,
      };
      staticUser(
        requestParams,
        localStorage.getItem("Authorization"),
        false
      ).then((res) => {
        let dataX = res.data.wordName;
        let dataY = res.data.number;
        for (let i = res.data.wordName.length; i < 20; i++) {
          dataX.push("");
          dataY.push(0);
        }
        /** 设置图表数据 */
        this.setChart(dataX, dataY, "keyWordChat");
      });
    },

    /** 旧版 需求捕获图表数据 */
    getChatData(index, id) {
      console.log(
        "this.dataList[index].searchParams.timeInterval++++",
        this.dataList[index].searchParams.timeInterval
      );
      let requestParams = {
        current: 1,
        size: 20,
        startTime:
          this.dataList[index].searchParams.timeInterval &&
          this.dataList[index].searchParams.timeInterval.length
            ? this.dataList[index].searchParams.timeInterval[0] + " 00:00:00"
            : "",
        endTime:
          this.dataList[index].searchParams.timeInterval &&
          this.dataList[index].searchParams.timeInterval.length
            ? this.dataList[index].searchParams.timeInterval[1] + " 23:59:59"
            : "",
        show: this.dataList[index].searchParams.searchType,
      };
      console.log("有没有进来？？？2223", requestParams);
      switch (id) {
        case "keyWordChat":
          console.log("没有进来？？？1+");
          /** 旧版 需求捕获图表数据  */
          this.getConsultChatData(requestParams, id);
          break;
        case "SensitiveWordsChat":
          console.log("没有进来？？？2+");
          /** 旧版 敏感词统计-图表数据  */
          this.getSensitiveChat(requestParams, id);
          break;
        case "employeeWordsChat":
          console.log("没有进来？？？3+");
          /** 旧版 敏感词统计-员工图表数据  */
          this.getUsersChat(requestParams, id);
          break;
      }
    },

    /** 旧版 需求捕获图表数据 */
    getConsultChatData(requestParams, id) {
      getConsultChat(
        requestParams,
        localStorage.getItem("Authorization"),
        false
      ).then((res) => {
        console.log("ddkafjdjfkjfk");
        let dataX = res.data.wordName;
        let dataY = res.data.number;
        for (let i = res.data.wordName.length; i < 20; i++) {
          dataX.push("");
          dataY.push(0);
        }

        this.setChart(dataX, dataY, id);
        // console.log("需求捕获图表表",res)
      });
    },

    /** 旧版 敏感词统计-员工图表 */
    getUsersChat(requestParams, id) {
      getUsersChat(
        requestParams,
        localStorage.getItem("Authorization"),
        false
      ).then((res) => {
        let dataX = res.data.userName;
        let dataY = res.data.number;
        for (let i = res.data.userName.length; i < 20; i++) {
          dataX.push("");
          dataY.push(0);
        }
        this.setChart(dataX, dataY, id, ["#f39423"]);
        // console.log("敏感词统计-员工图表",res)
      });
    },

    /** 旧版 敏感词统计-图表 */
    getSensitiveChat(requestParams, id) {
      getSensitiveChat(
        requestParams,
        localStorage.getItem("Authorization"),
        false
      ).then((res) => {
        let dataX = res.data.wordName;
        let dataY = res.data.number;
        for (let i = res.data.wordName.length; i < 20; i++) {
          dataX.push("");
          dataY.push(0);
        }
        this.setChart(dataX, dataY, id, ["#f39423"]);
        // console.log("敏感词统计-图表",res)
      });
    },

    /** 设置图表数据 */
    setChart(xData, yData, id, color = ["#2478f2"]) {
      console.log("fsfsdfdsfsdfsd", id);
      this.$nextTick(() => {
        let machart = this.$echarts.getInstanceByDom(
          document.getElementById(id)
        ); //有的话就获取已有echarts实例的DOM节点。
        if (machart == null) {
          // 如果不存在，就进行初始化。
          machart = this.$echarts.init(document.getElementById(id));
        }
        let option = {
          color,
          tooltip: {
            //设置tip提示
            trigger: "axis",
          },
          grid: {
            top: 20,
            right: 32,
            bottom: 40,
            left: 40,
          },
          yAxis: {},
          xAxis: {
            data: xData,
              bottom: '3%',
            axisLabel: {
              interval: 0,
              //  overflow: 'break',
              formatter: (value) => {
                // let ret = ""; //拼接加\n返回文字
                // let maxLength = 6; //换行字数
                // let valLength = value?.length || 0; //X轴类目项的文字个数
                // let rowN = Math.ceil(valLength / maxLength);
                // console.log("value++++", value);
                // for (var i = 0; i < value.length; i++) {
                let handleValue = "";
                if (value.length > 11) {
                  handleValue = value.substring(0, 6) + "\n";
                  handleValue += value.substring(6, 11) + "...";
                }else if (value.length > 6) {
                  handleValue = value.substring(0, 6) + "\n";
                  handleValue += value.substring(6)
                } else {
                  handleValue = value;
                }
                // }
                // if (rowN > 1) {
                //   for (var i = 0; i < value.length; i++) {
                //     let temp = "";
                //     let start = index * maxLength;
                //     let end = start + maxLength;
                //     if (valLength > 11) {
                //       if (index === 5) {
                //         temp = value.substring(start, end) + "\n";
                //       } else {
                //         temp += value.substring(5, 11) + "...";
                //       }
                //     } else if (valLength < 11 && valLength > 6) {
                //       temp = value.substring(start, end) + "\n";
                //       ret += temp;
                //     }
                //   }
                // value.forEach((item, index) => {
                //   let temp = "";
                //   let start = index * maxLength;
                //   let end = start + maxLength;
                //   if (valLength > 11) {
                //     if (index === 5) {
                //       temp = value.substring(start, end) + "\n";
                //     } else {
                //       temp += value.substring(5, 11) + "...";
                //     }
                //   } else if (valLength < 11 && valLength > 6) {
                //     temp = value.substring(start, end) + "\n";
                //     ret += temp;
                //   }
                // });
                return handleValue;
              },
            },
          },
          series: [
            {
              type: "bar",
              data: yData,
            },
          ],
        };
        // 使用刚指定的配置项和数据显示图表。
        machart.setOption(option);
        // 根据页面大小自动响应图表大小
        window.addEventListener("resize", function() {
          machart.resize();
        });
      });
    },

    /** 点击查看统计明细 */
    handleClickDetail(index, item) {
      switch (index) {
        case 0:
          this.type = 1;
          break;
        case 1:
          this.type = 2;
          break;
      }
      this.newKeyWordStatisticsDetailShow = true;
      this.$nextTick(() => {
        this.$refs.NewKeyWordStatisticsDetailRef.init(item);
      });
    },

    /** 关闭明细弹窗触发 */
    newKeyWordStatisticsDetailClose() {
      this.newKeyWordStatisticsDetailShow = false;
    },

    /** 时间改变的时候触发 */
    timeIntervalChange(index, id) {
      /** 因为新版暂时没有敏感词，所以先这么写2024.10.21 */
      if (this.isNewEdition) {
        /** 新版 */
        switch (index) {
          /** 关键词统计/需求捕捉词频 */
          case 0:
            /** 获取图表数据 */
            this.getkeyWordChatData();
            break;
          /** 敏感词词汇 */
          case 1:
            break;
          /** 员工敏感词统计 */
          case 2:
            break;
        }
      } else {
        /** 旧版 */
        this.getChatData(index, id);
      }
    },
  },

  /** 操作权限校验 */
  watch: {
    btnAuthority: {
      handler(newVal, oldVal) {
        if (newVal.length > 0) {
          newVal.forEach((item) => {
            if (item.pname == "敏感词统计") {
              let senBtnAuthority = item.cfunBu;
              if (senBtnAuthority.indexOf("mgctjdcdj") != -1) {
                // 可绑定、解绑
                this.mgctjdcdj = true;
              } else {
                this.mgctjdcdj = false;
              }
            }
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },

  /** 操作权限校验 */
  computed: {
    btnAuthority() {
      return this.$store.state.tagsView.roleAuthrority;
    },
  },

  /** 生命周期 */
  async mounted() {
    /** 获取进入系统后获取到的新旧版进行判断， */
    await this.getVersion();
    // this.getConsultChat();
  },
};
</script>

<style lang="scss" scoped>
.keyWord-statistics-container {
  background: #fff;
  // height: 100%;
  .module-wrap {
    // background: #fff;
    // display: flex;
    // flex-direction: column;
    // flex: 1;
    margin-bottom: 20px;
    .filter-bar {
      display: flex;
      // align-items: center;
      .filter-date-picker {
        width: 240px;
        margin-right: 10px;
        margin-bottom: 15px;
      }
    }
    .title-bar {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      padding: 10px;
      width: 95%;
      margin-bottom: 10px;
      .chat-title {
        font-weight: 600;
        font-size: 18px;
      }
      .detail-btn {
        cursor: pointer;
        color: #409eff;
      }
    }
  }
}
</style>
